import { motion } from "framer-motion";
import { CircleDashed, CircleDot, Circle } from "lucide-react";

const stages = [
  {
    icon: CircleDot,
    state: "Now",
    title: "Curriculum & institution building",
    body: "The SHE Global™ Boardroom Accelerator curriculum and the Institute's foundations are in active development.",
    active: true,
  },
  {
    icon: CircleDashed,
    state: "Next",
    title: "Founding interest list",
    body: "Women who express interest now will be the first to receive program details when they are finalized.",
    active: false,
  },
  {
    icon: Circle,
    state: "Ahead",
    title: "Program announcement",
    body: "Structure, dates, and fees will be published here — only when confirmed. No enrollment is open today.",
    active: false,
  },
];

const fadeUp = (delay = 0) => ({
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] } },
});

export const PreLaunch = () => (
  <section id="prelaunch" className="relative py-28 lg:py-40 bg-[#0E0E0E]" data-testid="prelaunch-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <div className="grid lg:grid-cols-12 gap-16">
        <motion.div variants={fadeUp()} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-100px" }} className="lg:col-span-5">
          <p className="text-[0.65rem] tracking-[0.4em] uppercase text-[#D4AF37] mb-6">Where We Are</p>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#F5F5F5]" data-testid="prelaunch-heading">
            Honest about our <em className="italic text-[#D4AF37]">stage.</em>
          </h2>
          <div className="mt-8 space-y-5 text-base leading-relaxed text-white" data-testid="prelaunch-disclosures">
            <p>SHE Global™ Institute and the SHE Global™ Boardroom Accelerator are currently in pre-launch.</p>
            <ul className="space-y-3 text-sm">
              <li className="flex gap-3"><span className="mt-[7px] h-1.5 w-1.5 rounded-full bg-[#D4AF37] shrink-0" /> Enrollment is not open, and no program dates or fees have been set.</li>
              <li className="flex gap-3"><span className="mt-[7px] h-1.5 w-1.5 rounded-full bg-[#D4AF37] shrink-0" /> The Institute does not claim accreditation or regulatory approval.</li>
              <li className="flex gap-3"><span className="mt-[7px] h-1.5 w-1.5 rounded-full bg-[#D4AF37] shrink-0" /> We do not promise board placements, employment, or income outcomes.</li>
              <li className="flex gap-3"><span className="mt-[7px] h-1.5 w-1.5 rounded-full bg-[#D4AF37] shrink-0" /> Expressing interest is non-binding and costs nothing.</li>
            </ul>
          </div>
        </motion.div>

        <div className="lg:col-span-7 flex flex-col justify-center gap-5">
          {stages.map((s, i) => (
            <motion.div
              key={s.title}
              variants={fadeUp(0.1 + i * 0.12)}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              className={`flex gap-8 items-start border p-10 ${s.active ? "border-[#D4AF37]/50 bg-[#141414]" : "border-white/10 bg-transparent"}`}
              data-testid={`prelaunch-stage-${i + 1}`}
            >
              <s.icon className={s.active ? "text-[#D4AF37]" : "text-white"} size={28} strokeWidth={1.25} />
              <div>
                <p className={`text-[0.6rem] tracking-[0.4em] uppercase mb-2 ${s.active ? "text-[#D4AF37]" : "text-white"}`}>{s.state}</p>
                <h3 className="font-serif-display text-2xl text-[#F5F5F5] mb-2">{s.title}</h3>
                <p className="text-sm leading-relaxed text-white">{s.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
